/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExplainResponse } from '../../models/explain-response';

export interface AuthzExplain$Json$Params {
  userId?: string;
  permission?: string;
}

export function authzExplain$Json(http: HttpClient, rootUrl: string, params?: AuthzExplain$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ExplainResponse>> {
  const rb = new RequestBuilder(rootUrl, authzExplain$Json.PATH, 'get');
  if (params) {
    rb.query('userId', params.userId, {});
    rb.query('permission', params.permission, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExplainResponse>;
    })
  );
}

authzExplain$Json.PATH = '/api/v1/platform/authz/explain';
